import React, { useRef, useState } from 'react';
import './org-invite-handler-modal.styles.scss';
import Modal, { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import org_icon from '@/assets/placeholder-icon-org.jpg'
import { useDispatch, useSelector } from 'react-redux';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import { properCase } from '@/utils/properCase';
import { UseCloudFunction } from '@/utils/firebase.utils';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import { setUserProfile } from '@/state/slices/userSlice';

const OrgInviteHandlerModal = ({
    invite,
    cancel,
    removeApprovedInvite
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const approveRef = useRef();
    const dispatch = useDispatch();

    async function acceptDecline(e) {
        setLoading(true);
        const now = new Date().getTime();
        const res = await UseCloudFunction(
            'acceptDeclineInvite', 
            {
                'accept': e,
                'inviteId': invite.id, 
                'ts': now, 
                'appId': userProfile.appId,
                'type': 'org'
            }
        )
        console.log(res);
        setLoading(false);
        if (res.error) {
            setAlertMessage(`Something went wrong. Error: ${res.error}`);
            cancel();
            return;
        }
        if (e) {
            dispatch(setUserProfile(res.profile));
        }
        cancel();
        removeApprovedInvite('org', invite.id);
    }

    return (
        <div className='invite-modal'>
            <Modal 
                show={invite}
                cancel={cancel}
                closeButton={true}
                text='You have been invited to join an Organization'
            >
                
            {
                (invite) &&
                <div className='invite-modal-content'>
                    <div className='g-card org-card'>
                        <ImageContainer src={invite.orgIcon ?? org_icon} className='org-img' />
                        <div className='org-info'>
                            <div className='org-title'>{invite.orgName}</div>
                            <div className='meta invite-date'>Added {format(new Date(invite.ts_created), "P")}</div>
                            <div className='meta'>Role: {properCase(invite.role[0])}</div>
                        </div>
                    </div>
                    <div className="g-space-20"></div>
                    <p>You have been added to the organization <b>{invite.orgName}</b>. Going forward, you will have access to all of the features Gamably offers. Plus you will have access to media and game content created and shared by other members of your organization. You will also be able to add other members of your organization as managers or distributors on games you create. Click "Get Started" below to continue.</p>
                    <div className='button-row'>
                        <button className='g-button primary' onClick={() => acceptDecline(true)}>Get Started</button>                    
                    </div>
                </div> 
            }
            </Modal>    
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
            <FullPageLoader
                show={loading} />
        </div>
    )
}

export default OrgInviteHandlerModal